// extracted by mini-css-extract-plugin
module.exports = {"header":"Invoices_header__1l9sV","noData":"Invoices_noData__1T6Ua","noDataTitle":"Invoices_noDataTitle__2Wq34"};